import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, useColorMode } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
import { Spinner } from '../Spinner';
export const SelectLoadingMessage = () => {
    const { colorMode } = useColorMode();
    return (_jsx(Flex, { mx: theme.sizes['4'], h: theme.sizes['10'], color: theme.colors[colorMode].text.tertiary, alignItems: "center", justifyContent: "center", children: _jsx(Spinner, { fontSize: theme.sizes['6'] }) }));
};
